import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import Table from "../components/Table";
import Layout from "../Layout";

export default function DriverLogs() {
  return (
    <Layout>
      <Stack height={"100%"}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: 2,
            px: 3,
            borderBlock: "1px solid",
            borderColor: "grey.300",
          }}
        >
          <Typography sx={{ ml: 1 }} component={"h1"} variant={"h5"}>
            Driver Logs
          </Typography>
        </Box>
        <Box sx={{ p: { sm: 4 } }} height="100%">
          <Box sx={{ p: 4 }}>
            <Table />
          </Box>
        </Box>
      </Stack>
    </Layout>
  );
}
